"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apply_service_const_1 = __importDefault(require("../../../../common/src/constrains/contract_form/apply_service_const"));
var date_parser_1 = __importDefault(require("../../../../common/src/utils/date/date_parser"));
var value_checker_1 = __importDefault(require("../../../../common/src/utils/validation/value_checker"));
var texts_1 = __importDefault(require("../../../../common/src/constrains/locale/texts"));
var price_utils_1 = __importDefault(require("../../../../common/src/utils/validation/price_utils"));
var object_utils_1 = __importDefault(require("../../../../common/src/utils/sales_force/object_utils"));
var ekyc_utils_1 = __importDefault(require("../../../../common/src/constrains/ekyc/ekyc_utils"));
var ContractCompleteMailTemplate = /** @class */ (function () {
    function ContractCompleteMailTemplate() {
    }
    ContractCompleteMailTemplate.getContents = function (contractInfo, salesForceInfo) {
        var requestPersonName = contractInfo.officeInfoRequestPersonLastName + " " + contractInfo.officeInfoRequestPersonFirstName;
        var requestPersonNameKana = contractInfo.officeInfoRequestPersonKanaLastName + " " + contractInfo.officeInfoRequestPersonKanaFirstName;
        var companyAddress = "\u3012" + contractInfo.officeInfoCorporateZip1 + "-" + contractInfo.officeInfoCorporateZip2 + " " + contractInfo.officeInfoCorporateAddress1 + " " + contractInfo.officeInfoCorporateAddress2 + " " + contractInfo.officeInfoCorporateAddress3;
        var officeAddress = "\u3012" + contractInfo.officeInfoZip1 + "-" + contractInfo.officeInfoZip2 + " " + contractInfo.officeInfoAddress1 + " " + contractInfo.officeInfoAddress2 + " " + contractInfo.officeInfoAddress3;
        var requestAddress = "\u3012" + contractInfo.requestInfoZip1 + "-" + contractInfo.requestInfoZip2 + " " + contractInfo.requestInfoAddress1 + " " + contractInfo.requestInfoAddress2 + " " + contractInfo.requestInfoAddress3;
        var tantosya = contractInfo.officeInfoTantosyaLastName + " " + contractInfo.officeInfoTantosyaFirstName;
        var tantosyaKana = contractInfo.officeInfoTantosyaKanaLastName + " " + contractInfo.officeInfoTantosyaKanaFirstName;
        var requestPerson = contractInfo.requestInfoRequestPersonLastName + " " + contractInfo.requestInfoRequestPersonFirstName;
        return contractInfo.officeInfoCompanyName + "\n" +
            (requestPersonName + "\u69D8\n") +
            '\n' +
            'このたびは、弊社サービスにお申込いただき、ありがとうございました。\n' +
            'お申込手続きが完了し契約内容が確定したため、ご連絡差し上げます。\n' +
            '\n' +
            '----------------------------------------------------------------\n' +
            '\n' +
            ("\u25A0" + ContractCompleteMailTemplate.getLabel('steps.office_info') + "\n") +
            '\n' +
            ContractCompleteMailTemplate.getDataRow('label.office_info.request_email', contractInfo.officeInfoRequestEmail) +
            ContractCompleteMailTemplate.getDataRow('label.office_info.request_person', requestPersonName) +
            ContractCompleteMailTemplate.getDataRow('label.office_info.request_person_kana', requestPersonNameKana) +
            ContractCompleteMailTemplate.getDataRow('label.office_info.office_no', contractInfo.officeInfoOfficeNo) +
            ContractCompleteMailTemplate.getDataRow('label.office_info.company_no', contractInfo.officeInfoCompanyNo) +
            ContractCompleteMailTemplate.getDataRow('label.office_info.company_name', contractInfo.officeInfoCorporateName) +
            ContractCompleteMailTemplate.getDataRow('label.office_info.corporate_address', companyAddress) +
            ContractCompleteMailTemplate.getDataRow('label.office_info.office_name', contractInfo.officeInfoOfficeName) +
            ContractCompleteMailTemplate.getDataRow('label.office_info.office_name_kana', contractInfo.officeInfoOfficeNameKana) +
            ContractCompleteMailTemplate.getDataRow('label.office_info.address', officeAddress) +
            ContractCompleteMailTemplate.getDataRow('label.office_info.tel', contractInfo.officeInfoTel) +
            ContractCompleteMailTemplate.getDataRow('label.office_info.tantosya', tantosya) +
            ContractCompleteMailTemplate.getDataRow('label.office_info.tantosya_kana', tantosyaKana) +
            ContractCompleteMailTemplate.getDataRow('label.office_info.tantosya_mail', contractInfo.officeInfoTantosyaMail) +
            '\n' +
            ("\u25A0" + ContractCompleteMailTemplate.getLabel('steps.request_info') + "\n") +
            '\n' +
            ContractCompleteMailTemplate.getDataRow('label.request_info.company_name', contractInfo.requestInfoCompanyName) +
            ContractCompleteMailTemplate.getDataRow('label.request_info.office_name', contractInfo.requestInfoOfficeName) +
            ContractCompleteMailTemplate.getDataRow('label.request_info.address', requestAddress) +
            ContractCompleteMailTemplate.getDataRow('label.request_info.tel', contractInfo.requestInfoTel) +
            ContractCompleteMailTemplate.getDataRow('label.request_info.request_person', requestPerson) +
            ContractCompleteMailTemplate.getDataRow('label.request_info.request_email', contractInfo.requestInfoRequestEmail) +
            ContractCompleteMailTemplate.getDataRow('label.request_info.how_to_request', contractInfo.requestInfoHowToRequest) +
            ContractCompleteMailTemplate.getDataRow('label.request_info.how_to_send', contractInfo.requestInfoHowToSend) +
            '\n' +
            ContractCompleteMailTemplate.getShippingContents(contractInfo) +
            ("\u25A0" + ContractCompleteMailTemplate.getLabel('steps.contract') + "\n") +
            '\n' +
            ContractCompleteMailTemplate.getDataRow('label.apply_info.apply_date', date_parser_1.default.toJapaneseDateStr(contractInfo.applyInfoApplyDate)) +
            '\n' +
            ContractCompleteMailTemplate.getKinoKunrenContents(contractInfo, salesForceInfo) +
            ContractCompleteMailTemplate.getOralCareContents(contractInfo, salesForceInfo) +
            ContractCompleteMailTemplate.getEntryContents(contractInfo, salesForceInfo) +
            ContractCompleteMailTemplate.getBasicContents(contractInfo, salesForceInfo) +
            ContractCompleteMailTemplate.getOldStandardContents(contractInfo, salesForceInfo) +
            ContractCompleteMailTemplate.getMediumContents(contractInfo, salesForceInfo) +
            ContractCompleteMailTemplate.getStandardContents(contractInfo, salesForceInfo) +
            ContractCompleteMailTemplate.getProfessionalContents(contractInfo, salesForceInfo) +
            ContractCompleteMailTemplate.getToUpgradeContents(contractInfo, salesForceInfo) +
            ContractCompleteMailTemplate.getMotionAiContents(contractInfo, salesForceInfo) +
            ContractCompleteMailTemplate.getUpgradeToStandardContents(contractInfo, salesForceInfo) +
            ContractCompleteMailTemplate.getAdditionalTabletContents(contractInfo, salesForceInfo) +
            '----------------------------------------------------------------\n' +
            '当サービスではマネーフォワードケッサイ株式会社が、請求業務の受託及び代金債権の収受権限の付与を受け、又は、販売元から当該債権の債権譲渡を受けて、請求書の発行や代金の回収、管理を行っております。\n' +
            '審査の結果、別のお支払方法をご提案する可能性がございます。予めご了承ください。\n' +
            '請求書の発行元およびご入金先口座名義は、マネーフォワードケッサイ株式会社となります。\n' +
            'お間違えのないようご注意ください。\n' +
            'その他、よくあるご質問やお問い合わせにつきましては下記をご参照ください。\n' +
            'https://inquiry.mfkessai.co.jp/\n' +
            '----------------------------------------------------------------\n' +
            '【お願い】\n' +
            '弊社サービスの品質向上のため、以下のリンクよりお客様満足度アンケートにご協力をお願いいたします。\n' +
            'https://docs.google.com/forms/d/e/1FAIpQLSea5iKLEUTr4nTkqb0geWkothO4PpWYhCD0H1rwh8N-tN2xXQ/viewform\n' +
            '（所要時間5分程度）\n' +
            '\n' +
            '【ご注意】\n' +
            '※こちらのメールアドレスは送信専用のため、返信いただいても対応できません。\n' +
            '\n' +
            'ご不明点は、下記連絡先までお問い合わせください。\n' +
            '\n' +
            '***************************************************************\n' +
            '株式会社Rehab for JAPAN\n' +
            '営業時間：10:00~18:00 [土・日・祝日除く]\n' +
            'TEL:050-5497-5155\n' +
            '***************************************************************';
    };
    ContractCompleteMailTemplate.getOralCareContents = function (contractInfo, salesForceInfo) {
        if (!contractInfo.applyInfoApplyService.includes(apply_service_const_1.default.ORAL_CARE)) {
            return '';
        }
        var bikoStr = '';
        if (ContractCompleteMailTemplate.isShowOralCareTokubetuDetail(salesForceInfo)) {
            var biko = '';
            if (value_checker_1.default.isPresent(salesForceInfo.oralCarePriceBookUrl)) {
                biko += "\n" + ContractCompleteMailTemplate.PARAGRAPH_SPACE + salesForceInfo.oralCarePriceBook2Description + "\u306E\u8A73\u7D30: " + salesForceInfo.oralCarePriceBookUrl + "\n" + ContractCompleteMailTemplate.PARAGRAPH_SPACE;
            }
            biko += "" + salesForceInfo.oralCareTokubetuDetail;
            bikoStr = ContractCompleteMailTemplate.PARAGRAPH_SPACE + ContractCompleteMailTemplate.getDataRow('label.contract.tokubetu_detail', biko);
        }
        return ContractCompleteMailTemplate.getLabel('label.apply_info.oral_care') + "\n" +
            ContractCompleteMailTemplate.PARAGRAPH_SPACE +
            ContractCompleteMailTemplate.getDataRow('label.apply_info.period', ContractCompleteMailTemplate.getOralCarePlanName(contractInfo, salesForceInfo)) +
            ContractCompleteMailTemplate.PARAGRAPH_SPACE +
            ContractCompleteMailTemplate.getDataRow('label.contract.price', ContractCompleteMailTemplate.getPriceStr(salesForceInfo.oralCcarePrice)) +
            ContractCompleteMailTemplate.PARAGRAPH_SPACE +
            ContractCompleteMailTemplate.getDataRow('label.apply_info.start_date', date_parser_1.default.toJapaneseDateStrNenGetu(contractInfo.applyInfoOralCareSstartDate)) +
            ContractCompleteMailTemplate.PARAGRAPH_SPACE +
            ContractCompleteMailTemplate.getDataRow('label.apply_info.plan_period', object_utils_1.default.getPlanPeriodStr(contractInfo.applyInfoOralCareSstartDate, salesForceInfo.oralCareFreePeriod, salesForceInfo.oralCarePriceBookMonth)) +
            ContractCompleteMailTemplate.PARAGRAPH_SPACE +
            ContractCompleteMailTemplate.getDataRow('label.contract.request_start_date', date_parser_1.default.toJapaneseDateStrNenGetu(salesForceInfo.oralCareRequestStartDate)) +
            bikoStr +
            '\n';
    };
    ContractCompleteMailTemplate.getKinoKunrenContents = function (contractInfo, salesForceInfo) {
        if (!contractInfo.applyInfoApplyService.includes(apply_service_const_1.default.KOBETSU)) {
            return '';
        }
        var bikoStr = '';
        if (ContractCompleteMailTemplate.isShowKobetuTokubetuDetail(salesForceInfo)) {
            var biko = '';
            if (value_checker_1.default.isPresent(salesForceInfo.kobetuPriceBookUrl)) {
                biko += "\n" + ContractCompleteMailTemplate.PARAGRAPH_SPACE + salesForceInfo.kobetuPriceBook2Description + "\u306E\u8A73\u7D30: " + salesForceInfo.kobetuPriceBookUrl + "\n" + ContractCompleteMailTemplate.PARAGRAPH_SPACE;
            }
            biko += "" + salesForceInfo.kobetuTokubetuDetail;
            bikoStr = ContractCompleteMailTemplate.PARAGRAPH_SPACE + ContractCompleteMailTemplate.getDataRow('label.contract.tokubetu_detail', biko);
        }
        return ContractCompleteMailTemplate.getLabel('label.apply_info.kino_kunren') + "\n" +
            ContractCompleteMailTemplate.PARAGRAPH_SPACE +
            ContractCompleteMailTemplate.getDataRow('label.apply_info.period', ContractCompleteMailTemplate.getKobetuPlanName(contractInfo, salesForceInfo)) +
            ContractCompleteMailTemplate.PARAGRAPH_SPACE +
            ContractCompleteMailTemplate.getDataRow('label.apply_info.apply_capacity', contractInfo.applyInfoApplyCapacity) +
            ContractCompleteMailTemplate.PARAGRAPH_SPACE +
            ContractCompleteMailTemplate.getDataRow('label.contract.price', ContractCompleteMailTemplate.getPriceStr(salesForceInfo.kobetuPrice)) +
            ContractCompleteMailTemplate.PARAGRAPH_SPACE +
            ContractCompleteMailTemplate.getDataRow('label.apply_info.start_date', date_parser_1.default.toJapaneseDateStrNenGetu(contractInfo.applyInfoKinoKunrenStartDate)) +
            ContractCompleteMailTemplate.PARAGRAPH_SPACE +
            ContractCompleteMailTemplate.getDataRow('label.apply_info.plan_period', object_utils_1.default.getPlanPeriodStr(contractInfo.applyInfoKinoKunrenStartDate, salesForceInfo.kobetuFreePeriod, salesForceInfo.kobetuPriceBookMonth)) +
            ContractCompleteMailTemplate.PARAGRAPH_SPACE +
            ContractCompleteMailTemplate.getDataRow('label.contract.request_start_date', date_parser_1.default.toJapaneseDateStrNenGetu(salesForceInfo.kobetuRequestStartDate)) +
            bikoStr +
            '\n';
    };
    ContractCompleteMailTemplate.getToUpgradeContents = function (contractInfo, salesForceInfo) {
        if (!contractInfo.applyInfoApplyService.includes(apply_service_const_1.default.UPGRADE)) {
            return '';
        }
        var bikoStr = '';
        if (ContractCompleteMailTemplate.isShowToUpgradeTokubetuDetail(salesForceInfo)) {
            var biko = '';
            biko += "" + salesForceInfo.toUpgradeTokubetuDetail;
            bikoStr = ContractCompleteMailTemplate.PARAGRAPH_SPACE + ContractCompleteMailTemplate.getDataRow('label.contract.tokubetu_detail', biko);
        }
        var result = '';
        if (salesForceInfo.toUpgradeData) {
            var limitedUpgradeTitle = object_utils_1.default.limitedPlanTexts("input_complete_upgrade_title", salesForceInfo.toUpgradeData, salesForceInfo.toUpgradeSelectedItem, salesForceInfo.previousPlan, salesForceInfo.contractPlan, salesForceInfo.toUpgradeStartDate);
            limitedUpgradeTitle += 'へのアップグレード';
            var limitedPreviousPlanName = object_utils_1.default.limitedPlanTexts("input_complete_previous_plan", salesForceInfo.toUpgradeData, salesForceInfo.toUpgradeSelectedItem, salesForceInfo.previousPlan, '', salesForceInfo.toUpgradeStartDate);
            var limitedAfterPlanName = object_utils_1.default.limitedPlanTexts("input_complete_after_plan", salesForceInfo.toUpgradeData, salesForceInfo.toUpgradeSelectedItem, salesForceInfo.previousPlan, salesForceInfo.contractPlan, salesForceInfo.toUpgradeStartDate);
            result += limitedUpgradeTitle + "\n";
            result += ContractCompleteMailTemplate.PARAGRAPH_SPACE;
            result += ContractCompleteMailTemplate.getDataRow('label.apply_info.previousPlan', limitedPreviousPlanName);
            result += ContractCompleteMailTemplate.PARAGRAPH_SPACE;
            result += ContractCompleteMailTemplate.getDataRow('label.apply_info.contractPlan', limitedAfterPlanName);
        }
        result += ContractCompleteMailTemplate.PARAGRAPH_SPACE;
        result += ContractCompleteMailTemplate.getDataRow('label.contract.price', ContractCompleteMailTemplate.getPriceStr(salesForceInfo.toUpgradePrice));
        result += ContractCompleteMailTemplate.PARAGRAPH_SPACE;
        result += ContractCompleteMailTemplate.getDataRow('label.apply_info.start_date', date_parser_1.default.toJapaneseDateStrNenGetu(contractInfo.toUpgradeStartDate));
        result += ContractCompleteMailTemplate.PARAGRAPH_SPACE;
        result += ContractCompleteMailTemplate.getDataRow('label.apply_info.plan_period', salesForceInfo.toUpradePlanPeriodStr);
        result += ContractCompleteMailTemplate.PARAGRAPH_SPACE;
        result += ContractCompleteMailTemplate.getDataRow('label.contract.request_start_date', date_parser_1.default.toJapaneseDateStrNenGetu(salesForceInfo.toUpgradeRequestStartDate));
        result += bikoStr;
        result += ekyc_utils_1.default.insertTabletImportantMatterSentence();
        result += '\n';
        result += '\n';
        return result;
    };
    ContractCompleteMailTemplate.getEntryContents = function (contractInfo, salesForceInfo) {
        if (!contractInfo.applyInfoApplyService.includes(apply_service_const_1.default.ENTRY)) {
            return '';
        }
        var bikoStr = '';
        if (ContractCompleteMailTemplate.isShowEntryTokubetuDetail(salesForceInfo)) {
            var biko = '';
            biko += "" + salesForceInfo.entryTokubetuDetail;
            bikoStr = ContractCompleteMailTemplate.PARAGRAPH_SPACE + ContractCompleteMailTemplate.getDataRow('label.contract.tokubetu_detail', biko);
        }
        var result = '';
        result += ContractCompleteMailTemplate.getLabel('label.apply_info.entry') + "\n";
        result += ContractCompleteMailTemplate.PARAGRAPH_SPACE;
        result += ContractCompleteMailTemplate.getDataRow('label.apply_info.period', ContractCompleteMailTemplate.getEntryPlanName(contractInfo, salesForceInfo));
        result += ContractCompleteMailTemplate.PARAGRAPH_SPACE;
        result += ContractCompleteMailTemplate.getDataRow('label.contract.price', ContractCompleteMailTemplate.getPriceStr(salesForceInfo.entryPrice));
        result += ContractCompleteMailTemplate.PARAGRAPH_SPACE;
        result += ContractCompleteMailTemplate.getDataRow('label.apply_info.start_date', date_parser_1.default.toJapaneseDateStrNenGetu(contractInfo.applyInfoEntryStartDate));
        result += ContractCompleteMailTemplate.PARAGRAPH_SPACE;
        result += ContractCompleteMailTemplate.getDataRow('label.apply_info.plan_period', object_utils_1.default.getPlanPeriodStr(contractInfo.applyInfoEntryStartDate, '', salesForceInfo.entryPriceBookMonth, salesForceInfo.entryProductPlanName));
        result += ContractCompleteMailTemplate.PARAGRAPH_SPACE;
        result += ContractCompleteMailTemplate.getDataRow('label.contract.request_start_date', date_parser_1.default.toJapaneseDateStrNenGetu(salesForceInfo.entryRequestStartDate));
        result += bikoStr;
        result += ekyc_utils_1.default.insertTabletImportantMatterSentence();
        result += '\n';
        result += '\n';
        return result;
    };
    ContractCompleteMailTemplate.getBasicContents = function (contractInfo, salesForceInfo) {
        if (!contractInfo.applyInfoApplyService.includes(apply_service_const_1.default.BASIC)) {
            return '';
        }
        var bikoStr = '';
        if (ContractCompleteMailTemplate.isShowBasicTokubetuDetail(salesForceInfo)) {
            var biko = '';
            if (value_checker_1.default.isPresent(salesForceInfo.basicPriceBookUrl)) {
                biko += "\n" + ContractCompleteMailTemplate.PARAGRAPH_SPACE + salesForceInfo.basicPriceBook2Description + "\u306E\u8A73\u7D30: " + salesForceInfo.basicPriceBookUrl + "\n" + ContractCompleteMailTemplate.PARAGRAPH_SPACE;
            }
            biko += "" + salesForceInfo.basicTokubetuDetail;
            bikoStr = ContractCompleteMailTemplate.PARAGRAPH_SPACE + ContractCompleteMailTemplate.getDataRow('label.contract.tokubetu_detail', biko);
        }
        return ContractCompleteMailTemplate.getLabel('label.apply_info.basic') + "\n" +
            ContractCompleteMailTemplate.PARAGRAPH_SPACE +
            ContractCompleteMailTemplate.getDataRow('label.apply_info.period', ContractCompleteMailTemplate.getBasicPlanName(contractInfo, salesForceInfo)) +
            ContractCompleteMailTemplate.PARAGRAPH_SPACE +
            ContractCompleteMailTemplate.getDataRow('label.contract.price', ContractCompleteMailTemplate.getPriceStr(salesForceInfo.basicPrice)) +
            ContractCompleteMailTemplate.PARAGRAPH_SPACE +
            ContractCompleteMailTemplate.getDataRow('label.apply_info.start_date', date_parser_1.default.toJapaneseDateStrNenGetu(contractInfo.applyInfoBasicStartDate)) +
            ContractCompleteMailTemplate.PARAGRAPH_SPACE +
            ContractCompleteMailTemplate.getDataRow('label.apply_info.plan_period', object_utils_1.default.getPlanPeriodStr(contractInfo.applyInfoBasicStartDate, '', salesForceInfo.basicPriceBookMonth, salesForceInfo.basicProductPlanName)) +
            ContractCompleteMailTemplate.PARAGRAPH_SPACE +
            ContractCompleteMailTemplate.getDataRow('label.contract.request_start_date', date_parser_1.default.toJapaneseDateStrNenGetu(salesForceInfo.basicRequestStartDate)) +
            bikoStr +
            '\n';
    };
    ContractCompleteMailTemplate.getMediumContents = function (contractInfo, salesForceInfo) {
        if (!contractInfo.applyInfoApplyService.includes(apply_service_const_1.default.MEDIUM)) {
            return '';
        }
        var bikoStr = '';
        if (ContractCompleteMailTemplate.isShowMediumTokubetuDetail(salesForceInfo)) {
            var biko = '';
            biko += "" + salesForceInfo.mediumTokubetuDetail;
            bikoStr = ContractCompleteMailTemplate.PARAGRAPH_SPACE + ContractCompleteMailTemplate.getDataRow('label.contract.tokubetu_detail', biko);
        }
        var result = '';
        result += ContractCompleteMailTemplate.getLabel('label.apply_info.medium') + "\n";
        result += ContractCompleteMailTemplate.PARAGRAPH_SPACE;
        result += ContractCompleteMailTemplate.getDataRow('label.apply_info.period', ContractCompleteMailTemplate.getMediumPlanName(contractInfo, salesForceInfo));
        result += ContractCompleteMailTemplate.PARAGRAPH_SPACE;
        result += ContractCompleteMailTemplate.getDataRow('label.contract.price', ContractCompleteMailTemplate.getPriceStr(salesForceInfo.mediumPrice));
        result += ContractCompleteMailTemplate.PARAGRAPH_SPACE;
        result += ContractCompleteMailTemplate.getDataRow('label.apply_info.start_date', date_parser_1.default.toJapaneseDateStrNenGetu(contractInfo.applyInfoMediumStartDate));
        result += ContractCompleteMailTemplate.PARAGRAPH_SPACE;
        result += ContractCompleteMailTemplate.getDataRow('label.apply_info.plan_period', object_utils_1.default.getPlanPeriodStr(contractInfo.applyInfoMediumStartDate, '', salesForceInfo.mediumPriceBookMonth, salesForceInfo.mediumProductPlanName));
        result += ContractCompleteMailTemplate.PARAGRAPH_SPACE;
        result += ContractCompleteMailTemplate.getDataRow('label.contract.request_start_date', date_parser_1.default.toJapaneseDateStrNenGetu(salesForceInfo.mediumRequestStartDate));
        result += bikoStr;
        result += ekyc_utils_1.default.insertTabletImportantMatterSentence();
        result += '\n';
        result += '\n';
        return result;
    };
    ContractCompleteMailTemplate.getStandardContents = function (contractInfo, salesForceInfo) {
        if (!contractInfo.applyInfoApplyService.includes(apply_service_const_1.default.STANDARD)) {
            return '';
        }
        var bikoStr = '';
        if (ContractCompleteMailTemplate.isShowStandardTokubetuDetail(salesForceInfo)) {
            var biko = '';
            if (value_checker_1.default.isPresent(salesForceInfo.standardPriceBookUrl)) {
                biko += "\n" + ContractCompleteMailTemplate.PARAGRAPH_SPACE + salesForceInfo.standardPriceBook2Description + "\u306E\u8A73\u7D30: " + salesForceInfo.standardPriceBookUrl + "\n" + ContractCompleteMailTemplate.PARAGRAPH_SPACE;
            }
            biko += "" + salesForceInfo.standardTokubetuDetail;
            bikoStr = ContractCompleteMailTemplate.PARAGRAPH_SPACE + ContractCompleteMailTemplate.getDataRow('label.contract.tokubetu_detail', biko);
        }
        var result = '';
        result += ContractCompleteMailTemplate.getLabel('label.apply_info.standard') + "\n";
        result += ContractCompleteMailTemplate.PARAGRAPH_SPACE;
        result += ContractCompleteMailTemplate.getDataRow('label.apply_info.period', ContractCompleteMailTemplate.getStandardPlanName(contractInfo, salesForceInfo));
        result += ContractCompleteMailTemplate.PARAGRAPH_SPACE;
        result += ContractCompleteMailTemplate.getDataRow('label.contract.price', ContractCompleteMailTemplate.getPriceStr(salesForceInfo.standardPrice));
        result += ContractCompleteMailTemplate.PARAGRAPH_SPACE;
        result += ContractCompleteMailTemplate.getDataRow('label.apply_info.start_date', date_parser_1.default.toJapaneseDateStrNenGetu(contractInfo.applyInfoStandardStartDate));
        result += ContractCompleteMailTemplate.PARAGRAPH_SPACE;
        result += ContractCompleteMailTemplate.getDataRow('label.apply_info.plan_period', object_utils_1.default.getPlanPeriodStr(contractInfo.applyInfoStandardStartDate, '', salesForceInfo.standardPriceBookMonth, salesForceInfo.standardProductPlanName));
        result += ContractCompleteMailTemplate.PARAGRAPH_SPACE;
        result += ContractCompleteMailTemplate.getDataRow('label.contract.request_start_date', date_parser_1.default.toJapaneseDateStrNenGetu(salesForceInfo.standardRequestStartDate));
        result += bikoStr;
        result += ekyc_utils_1.default.insertTabletImportantMatterSentence();
        result += '\n';
        result += '\n';
        return result;
    };
    ContractCompleteMailTemplate.getProfessionalContents = function (contractInfo, salesForceInfo) {
        if (!contractInfo.applyInfoApplyService.includes(apply_service_const_1.default.PROFESSIONAL)) {
            return '';
        }
        var bikoStr = '';
        if (ContractCompleteMailTemplate.isShowProfessionalTokubetuDetail(salesForceInfo)) {
            var biko = '';
            biko += "" + salesForceInfo.professionalTokubetuDetail;
            bikoStr = ContractCompleteMailTemplate.PARAGRAPH_SPACE + ContractCompleteMailTemplate.getDataRow('label.contract.tokubetu_detail', biko);
        }
        var result = '';
        result += ContractCompleteMailTemplate.getLabel('label.apply_info.professional') + "\n";
        result += ContractCompleteMailTemplate.PARAGRAPH_SPACE;
        result += ContractCompleteMailTemplate.getDataRow('label.apply_info.period', ContractCompleteMailTemplate.getProfessionalPlanName(contractInfo, salesForceInfo));
        result += ContractCompleteMailTemplate.PARAGRAPH_SPACE;
        result += ContractCompleteMailTemplate.getDataRow('label.contract.price', ContractCompleteMailTemplate.getPriceStr(salesForceInfo.professionalPrice));
        result += ContractCompleteMailTemplate.PARAGRAPH_SPACE;
        result += ContractCompleteMailTemplate.getDataRow('label.apply_info.start_date', date_parser_1.default.toJapaneseDateStrNenGetu(contractInfo.applyInfoProfessionalStartDate));
        result += ContractCompleteMailTemplate.PARAGRAPH_SPACE;
        result += ContractCompleteMailTemplate.getDataRow('label.apply_info.plan_period', object_utils_1.default.getPlanPeriodStr(contractInfo.applyInfoProfessionalStartDate, '', salesForceInfo.professionalPriceBookMonth, salesForceInfo.professionalProductPlanName));
        result += ContractCompleteMailTemplate.PARAGRAPH_SPACE;
        result += ContractCompleteMailTemplate.getDataRow('label.contract.request_start_date', date_parser_1.default.toJapaneseDateStrNenGetu(salesForceInfo.professionalRequestStartDate));
        result += bikoStr;
        result += ekyc_utils_1.default.insertTabletImportantMatterSentence();
        result += '\n';
        result += '\n';
        return result;
    };
    ContractCompleteMailTemplate.getMotionAiContents = function (contractInfo, salesForceInfo) {
        if (!contractInfo.applyInfoApplyService.includes(apply_service_const_1.default.MOTION_AI)) {
            return '';
        }
        var bikoStr = '';
        if (ContractCompleteMailTemplate.isShowMotionAiTokubetuDetail(salesForceInfo)) {
            var biko = '';
            if (value_checker_1.default.isPresent(salesForceInfo.motionAiPriceBookUrl)) {
                biko += "\n" + ContractCompleteMailTemplate.PARAGRAPH_SPACE + salesForceInfo.motionAiPriceBook2Description + "\u306E\u8A73\u7D30: " + salesForceInfo.motionAiPriceBookUrl + "\n" + ContractCompleteMailTemplate.PARAGRAPH_SPACE;
            }
            biko += "" + salesForceInfo.motionAiTokubetuDetail;
            bikoStr = ContractCompleteMailTemplate.PARAGRAPH_SPACE + ContractCompleteMailTemplate.getDataRow('label.contract.tokubetu_detail', biko);
        }
        return ContractCompleteMailTemplate.getLabel('label.apply_info.motion_ai') + "\n" +
            ContractCompleteMailTemplate.PARAGRAPH_SPACE +
            ContractCompleteMailTemplate.getDataRow('label.apply_info.period', ContractCompleteMailTemplate.getMotionAiPlanName(contractInfo, salesForceInfo)) +
            ContractCompleteMailTemplate.PARAGRAPH_SPACE +
            ContractCompleteMailTemplate.getDataRow('label.contract.price', ContractCompleteMailTemplate.getPriceStr(salesForceInfo.motionAiPrice)) +
            ContractCompleteMailTemplate.PARAGRAPH_SPACE +
            ContractCompleteMailTemplate.getDataRow('label.apply_info.start_date', date_parser_1.default.toJapaneseDateStrNenGetu(contractInfo.applyInfoMotionAiStartDate)) +
            ContractCompleteMailTemplate.PARAGRAPH_SPACE +
            ContractCompleteMailTemplate.getDataRow('label.apply_info.plan_period', object_utils_1.default.getPlanPeriodStr(contractInfo.applyInfoMotionAiStartDate, '', salesForceInfo.motionAiPriceBookMonth, salesForceInfo.motionAiProductPlanName)) +
            ContractCompleteMailTemplate.PARAGRAPH_SPACE +
            ContractCompleteMailTemplate.getDataRow('label.contract.request_start_date', date_parser_1.default.toJapaneseDateStrNenGetu(salesForceInfo.motionAiRequestStartDate)) +
            bikoStr +
            '\n';
    };
    ContractCompleteMailTemplate.getUpgradeToStandardContents = function (contractInfo, salesForceInfo) {
        if (!contractInfo.applyInfoApplyService.includes(apply_service_const_1.default.UPGRADE_TO_STANDARD)) {
            return '';
        }
        var bikoStr = '';
        if (ContractCompleteMailTemplate.isShowStandardTokubetuDetail(salesForceInfo)) {
            var biko = '';
            if (value_checker_1.default.isPresent(salesForceInfo.standardPriceBookUrl)) {
                biko += "\n" + ContractCompleteMailTemplate.PARAGRAPH_SPACE + salesForceInfo.standardPriceBook2Description + "\u306E\u8A73\u7D30: " + salesForceInfo.standardPriceBookUrl + "\n" + ContractCompleteMailTemplate.PARAGRAPH_SPACE;
            }
            biko += "" + salesForceInfo.standardTokubetuDetail;
            bikoStr = ContractCompleteMailTemplate.PARAGRAPH_SPACE + ContractCompleteMailTemplate.getDataRow('label.contract.tokubetu_detail', biko);
        }
        var tabletSentence = "\u30BF\u30D6\u30EC\u30C3\u30C8\u30EC\u30F3\u30BF\u30EB\u306B\u3064\u3044\u3066\u306E\u91CD\u8981\u4E8B\u9805\u306F\u4EE5\u4E0B\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002\nhttps://rehab.cloud/spguide/";
        return ContractCompleteMailTemplate.getLabel('label.apply_info.upgrade_to_standard') + "\n" +
            ContractCompleteMailTemplate.PARAGRAPH_SPACE +
            ContractCompleteMailTemplate.getDataRow('label.apply_info.period', 'アップグレード' + ContractCompleteMailTemplate.getStandardPlanName(contractInfo, salesForceInfo)) +
            ContractCompleteMailTemplate.PARAGRAPH_SPACE +
            ContractCompleteMailTemplate.getDataRow('label.contract.price', ContractCompleteMailTemplate.getPriceStr(salesForceInfo.standardPrice)) +
            ContractCompleteMailTemplate.PARAGRAPH_SPACE +
            ContractCompleteMailTemplate.getDataRow('label.apply_info.start_date', date_parser_1.default.toJapaneseDateStrNenGetu(contractInfo.applyInfoStandardStartDate)) +
            ContractCompleteMailTemplate.PARAGRAPH_SPACE +
            ContractCompleteMailTemplate.getDataRow('label.apply_info.plan_period', object_utils_1.default.getPlanPeriodStr(contractInfo.applyInfoStandardStartDate, '', salesForceInfo.standardPriceBookMonth, salesForceInfo.standardProductPlanName)) +
            ContractCompleteMailTemplate.PARAGRAPH_SPACE +
            ContractCompleteMailTemplate.getDataRow('label.contract.request_start_date', date_parser_1.default.toJapaneseDateStrNenGetu(salesForceInfo.standardRequestStartDate)) +
            bikoStr +
            tabletSentence +
            '\n';
    };
    ContractCompleteMailTemplate.getAdditionalTabletContents = function (contractInfo, salesForceInfo) {
        if (!contractInfo.applyInfoApplyService.includes(apply_service_const_1.default.ADDITIONAL_TABLET)) {
            return '';
        }
        var bikoStr = '';
        var contents = '';
        var rehabCloudTabletMonthly = '';
        var rehabCloudTabletInitialFeeMonthly = '';
        if (value_checker_1.default.isPresent(salesForceInfo.additionalTabletTokubetuDetail)) {
            var biko = '';
            biko += "" + salesForceInfo.additionalTabletTokubetuDetail;
            bikoStr = ContractCompleteMailTemplate.PARAGRAPH_SPACE + ContractCompleteMailTemplate.getDataRow('label.contract.tokubetu_detail', biko);
        }
        if (salesForceInfo.displayDataTableObj &&
            value_checker_1.default.isPresent(String(salesForceInfo.displayDataTableObj["rehabCloudTabletMonthly"]))) {
            // 販売価格（税抜）
            rehabCloudTabletMonthly = '¥' + salesForceInfo.displayDataTableObj["rehabCloudTabletMonthly"].toLocaleString();
            rehabCloudTabletMonthly += ' ✕ ';
            rehabCloudTabletMonthly += salesForceInfo.additionalTablets + "\u53F0";
            // 初回手数料（税抜）
            rehabCloudTabletInitialFeeMonthly = '¥' + salesForceInfo.displayDataTableObj["initialFeeTotalPrice"].toLocaleString();
            rehabCloudTabletInitialFeeMonthly += "\uFF08\u00A5" + salesForceInfo.displayDataTableObj["rehabCloudTabletInitialFeeMonthly"].toLocaleString();
            rehabCloudTabletInitialFeeMonthly += ' ✕ ';
            rehabCloudTabletInitialFeeMonthly += salesForceInfo.additionalTablets + "\u53F0\u5206\uFF09";
        }
        var tabletSentence = "\u30BF\u30D6\u30EC\u30C3\u30C8\u30EC\u30F3\u30BF\u30EB\u306B\u3064\u3044\u3066\u306E\u91CD\u8981\u4E8B\u9805\u306F\u4EE5\u4E0B\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002\nhttps://rehab.cloud/spguide/";
        // タイトル
        contents = ContractCompleteMailTemplate.getLabel('label.apply_info.additional_tablet') + "\n";
        contents += ContractCompleteMailTemplate.PARAGRAPH_SPACE;
        // 申込プラン
        contents += ContractCompleteMailTemplate.getDataRow('label.apply_info.period', '月間プラン（月々払い）');
        contents += ContractCompleteMailTemplate.PARAGRAPH_SPACE;
        // タブレット台数
        contents += ContractCompleteMailTemplate.getDataRow('label.apply_info.tablet_numbers', salesForceInfo.additionalTablets + '台');
        contents += ContractCompleteMailTemplate.PARAGRAPH_SPACE;
        // 利用開始月
        contents += ContractCompleteMailTemplate.getDataRow('label.apply_info.start_date', date_parser_1.default.toJapaneseDateStrNenGetu(contractInfo.applyInfoAdditionalTabletStartDate));
        contents += ContractCompleteMailTemplate.PARAGRAPH_SPACE;
        // 販売価格（税抜）
        contents += ContractCompleteMailTemplate.getDataRow('label.apply_info.price', rehabCloudTabletMonthly);
        contents += ContractCompleteMailTemplate.PARAGRAPH_SPACE;
        // 初回手数料（税抜）
        contents += ContractCompleteMailTemplate.getDataRow('label.apply_info.initial_fee', rehabCloudTabletInitialFeeMonthly);
        contents += bikoStr;
        contents += tabletSentence;
        contents += '\n';
        contents += '\n';
        return contents;
    };
    ContractCompleteMailTemplate.getOldStandardContents = function (contractInfo, salesForceInfo) {
        if (!contractInfo.applyInfoApplyService.includes(apply_service_const_1.default.OLD_STANDARD)) {
            return '';
        }
        var bikoStr = '';
        if (ContractCompleteMailTemplate.isShowOldStandardTokubetuDetail(salesForceInfo)) {
            var biko = '';
            biko += "" + salesForceInfo.oldStandardTokubetuDetail;
            bikoStr = ContractCompleteMailTemplate.PARAGRAPH_SPACE + ContractCompleteMailTemplate.getDataRow('label.contract.tokubetu_detail', biko);
        }
        var result = '';
        result += ContractCompleteMailTemplate.getLabel('label.apply_info.old_standard') + "\n";
        result += ContractCompleteMailTemplate.PARAGRAPH_SPACE;
        result += ContractCompleteMailTemplate.getDataRow('label.apply_info.period', ContractCompleteMailTemplate.getOldStandardPlanName(contractInfo, salesForceInfo));
        result += ContractCompleteMailTemplate.PARAGRAPH_SPACE;
        result += ContractCompleteMailTemplate.getDataRow('label.contract.price', ContractCompleteMailTemplate.getPriceStr(salesForceInfo.oldStandardPrice));
        result += ContractCompleteMailTemplate.PARAGRAPH_SPACE;
        result += ContractCompleteMailTemplate.getDataRow('label.apply_info.start_date', date_parser_1.default.toJapaneseDateStrNenGetu(contractInfo.applyInfoOldStandardStartDate));
        result += ContractCompleteMailTemplate.PARAGRAPH_SPACE;
        result += ContractCompleteMailTemplate.getDataRow('label.apply_info.plan_period', object_utils_1.default.getPlanPeriodStr(contractInfo.applyInfoOldStandardStartDate, '', salesForceInfo.oldStandardPriceBookMonth, salesForceInfo.oldStandardProductPlanName));
        result += ContractCompleteMailTemplate.PARAGRAPH_SPACE;
        result += ContractCompleteMailTemplate.getDataRow('label.contract.request_start_date', date_parser_1.default.toJapaneseDateStrNenGetu(salesForceInfo.oldStandardRequestStartDate));
        result += bikoStr;
        result += ekyc_utils_1.default.insertTabletImportantMatterSentence();
        result += '\n';
        result += '\n';
        return result;
    };
    // タブレット必須のプラン申込時に配送先テキストを出力する。
    // 2023-12-21 本人確認スキップの条件の場合は、配送先テキストを出力しない条件を追加する。
    // タブレット単体の場合はpersonalEkycSkipFlgをチェックしない。※必ず本人確認の再チェックが必要なため
    ContractCompleteMailTemplate.getShippingContents = function (contractInfo) {
        var isPersonalEkycSkipFlg = contractInfo.personalEkycSkipFlg === "true";
        if (contractInfo.applyInfoApplyService.includes(apply_service_const_1.default.UPGRADE_TO_STANDARD) && !isPersonalEkycSkipFlg ||
            contractInfo.applyInfoApplyService.includes(apply_service_const_1.default.STANDARD) && !isPersonalEkycSkipFlg ||
            contractInfo.applyInfoApplyService.includes(apply_service_const_1.default.ADDITIONAL_TABLET) ||
            contractInfo.applyInfoApplyService.includes(apply_service_const_1.default.ENTRY) && !isPersonalEkycSkipFlg ||
            contractInfo.applyInfoApplyService.includes(apply_service_const_1.default.OLD_STANDARD) && !isPersonalEkycSkipFlg ||
            contractInfo.applyInfoApplyService.includes(apply_service_const_1.default.MEDIUM) && !isPersonalEkycSkipFlg ||
            contractInfo.applyInfoApplyService.includes(apply_service_const_1.default.PROFESSIONAL) && !isPersonalEkycSkipFlg ||
            contractInfo.applyInfoApplyService.includes(apply_service_const_1.default.UPGRADE) && !isPersonalEkycSkipFlg) {
            var shippingAddress = "\u3012" + contractInfo.shippingAddressInfoZip1 + "-" + contractInfo.shippingAddressInfoZip2 + " " + contractInfo.shippingAddressInfoAddress1 + " " + contractInfo.shippingAddressInfoAddress2 + " " + contractInfo.shippingAddressInfoAddress3;
            return '\n' +
                ("\u25A0" + ContractCompleteMailTemplate.getLabel('steps.shipping_address_info') + "\n") +
                '\n' +
                ContractCompleteMailTemplate.getDataRow('label.shipping_address_info.company_name', contractInfo.shippingAddressInfoCompanyName) +
                ContractCompleteMailTemplate.getDataRow('label.shipping_address_info.office_name', contractInfo.shippingAddressInfoOfficeName) +
                ContractCompleteMailTemplate.getDataRow('label.shipping_address_info.tel', contractInfo.shippingAddressInfoTel) +
                ContractCompleteMailTemplate.getDataRow('label.shipping_address_info.address', shippingAddress) +
                ContractCompleteMailTemplate.getDataRow('label.shipping_address_info.request_person', contractInfo.shippingAddressInfoPersonLastName + " " + contractInfo.shippingAddressInfoPersonFirstName) +
                '\n';
        }
        else {
            return '';
        }
    };
    ContractCompleteMailTemplate.isShowKobetuTokubetuDetail = function (formData) {
        return value_checker_1.default.isPresent(formData.kobetuPriceBookUrl) ||
            value_checker_1.default.isPresent(formData.kobetuTokubetuDetail);
    };
    ContractCompleteMailTemplate.isShowOralCareTokubetuDetail = function (formData) {
        return value_checker_1.default.isPresent(formData.oralCarePriceBookUrl) ||
            value_checker_1.default.isPresent(formData.oralCareTokubetuDetail);
    };
    ContractCompleteMailTemplate.isShowBasicTokubetuDetail = function (formData) {
        return value_checker_1.default.isPresent(formData.basicPriceBookUrl) ||
            value_checker_1.default.isPresent(formData.basicTokubetuDetail);
    };
    ContractCompleteMailTemplate.isShowEntryTokubetuDetail = function (formData) {
        return value_checker_1.default.isPresent(formData.entryPriceBookUrl) ||
            value_checker_1.default.isPresent(formData.entryTokubetuDetail);
    };
    ContractCompleteMailTemplate.isShowToUpgradeTokubetuDetail = function (formData) {
        return value_checker_1.default.isPresent(formData.toUpgradeTokubetuDetail);
    };
    ContractCompleteMailTemplate.isShowMediumTokubetuDetail = function (formData) {
        return value_checker_1.default.isPresent(formData.mediumPriceBookUrl) ||
            value_checker_1.default.isPresent(formData.mediumTokubetuDetail);
    };
    ContractCompleteMailTemplate.isShowStandardTokubetuDetail = function (formData) {
        return value_checker_1.default.isPresent(formData.standardPriceBookUrl) ||
            value_checker_1.default.isPresent(formData.standardTokubetuDetail);
    };
    ContractCompleteMailTemplate.isShowProfessionalTokubetuDetail = function (formData) {
        return value_checker_1.default.isPresent(formData.professionalPriceBookUrl) ||
            value_checker_1.default.isPresent(formData.professionalTokubetuDetail);
    };
    ContractCompleteMailTemplate.isShowMotionAiTokubetuDetail = function (formData) {
        return value_checker_1.default.isPresent(formData.motionAiPriceBookUrl) ||
            value_checker_1.default.isPresent(formData.motionAiTokubetuDetail);
    };
    ContractCompleteMailTemplate.isShowOldStandardTokubetuDetail = function (formData) {
        return value_checker_1.default.isPresent(formData.oldStandardPriceBookUrl) ||
            value_checker_1.default.isPresent(formData.oldStandardTokubetuDetail);
    };
    ContractCompleteMailTemplate.isShowKobetuBikoLink = function (formData) {
    };
    ContractCompleteMailTemplate.getPriceStr = function (value) {
        return price_utils_1.default.getPriceStr(value);
    };
    ContractCompleteMailTemplate.getLabel = function (labelName) {
        var labels = labelName.split('.');
        var result = texts_1.default.ja.view.contract_form.update;
        labels.forEach(function (label) {
            result = result[label];
        });
        if (!result) {
            return '';
        }
        return result.toString();
    };
    ContractCompleteMailTemplate.getDataRow = function (labelName, data) {
        return ContractCompleteMailTemplate.getLabel(labelName) + ": " + data + "\n";
    };
    Object.defineProperty(ContractCompleteMailTemplate, "PARAGRAPH_SPACE", {
        get: function () {
            return '　　';
        },
        enumerable: true,
        configurable: true
    });
    ContractCompleteMailTemplate.getKobetuPlanName = function (contractDocument, salesForceInfo) {
        if (value_checker_1.default.isPresent(contractDocument.applyInfoKinoKunrenPeriod)) {
            return contractDocument.applyInfoKinoKunrenPeriod;
        }
        return object_utils_1.default.getApplyPlanText(salesForceInfo.kobetuProductPlanName, salesForceInfo.kobetuPriceBook2Description);
    };
    ContractCompleteMailTemplate.getOralCarePlanName = function (contractDocument, salesForceInfo) {
        if (value_checker_1.default.isPresent(contractDocument.applyInfoOralCarePeriod)) {
            return contractDocument.applyInfoOralCarePeriod;
        }
        return object_utils_1.default.getApplyPlanText(salesForceInfo.oralCareProductPlanName, salesForceInfo.oralCarePriceBook2Description);
    };
    ContractCompleteMailTemplate.getEntryPlanName = function (contractDocument, salesForceInfo) {
        if (value_checker_1.default.isPresent(contractDocument.applyInfoEntryPeriod)) {
            return contractDocument.applyInfoEntryPeriod;
        }
        return object_utils_1.default.getApplyPlanText(salesForceInfo.entryProductPlanName, salesForceInfo.entryPriceBook2Description);
    };
    ContractCompleteMailTemplate.getBasicPlanName = function (contractDocument, salesForceInfo) {
        if (value_checker_1.default.isPresent(contractDocument.applyInfoBasicPeriod)) {
            return contractDocument.applyInfoBasicPeriod;
        }
        return object_utils_1.default.getApplyPlanText(salesForceInfo.basicProductPlanName, salesForceInfo.basicPriceBook2Description);
    };
    ContractCompleteMailTemplate.getMediumPlanName = function (contractDocument, salesForceInfo) {
        if (value_checker_1.default.isPresent(contractDocument.applyInfoMediumPeriod)) {
            return contractDocument.applyInfoMediumPeriod;
        }
        return object_utils_1.default.getApplyPlanText(salesForceInfo.mediumProductPlanName, salesForceInfo.mediumPriceBook2Description);
    };
    ContractCompleteMailTemplate.getStandardPlanName = function (contractDocument, salesForceInfo) {
        if (value_checker_1.default.isPresent(contractDocument.applyInfoStandardPeriod)) {
            return contractDocument.applyInfoStandardPeriod;
        }
        return object_utils_1.default.getApplyPlanText(salesForceInfo.standardProductPlanName, salesForceInfo.standardPriceBook2Description);
    };
    ContractCompleteMailTemplate.getProfessionalPlanName = function (contractDocument, salesForceInfo) {
        if (value_checker_1.default.isPresent(contractDocument.applyInfoProfessionalPeriod)) {
            return contractDocument.applyInfoProfessionalPeriod;
        }
        return object_utils_1.default.getApplyPlanText(salesForceInfo.professionalProductPlanName, salesForceInfo.professionalPriceBook2Description);
    };
    ContractCompleteMailTemplate.getMotionAiPlanName = function (contractDocument, salesForceInfo) {
        if (value_checker_1.default.isPresent(contractDocument.applyInfoMotionAiPeriod)) {
            return contractDocument.applyInfoMotionAiPeriod;
        }
        return object_utils_1.default.getApplyPlanText(salesForceInfo.motionAiProductPlanName, salesForceInfo.motionAiPriceBook2Description);
    };
    ContractCompleteMailTemplate.getOldStandardPlanName = function (contractDocument, salesForceInfo) {
        if (value_checker_1.default.isPresent(contractDocument.applyInfoOldStandardPeriod)) {
            return contractDocument.applyInfoOldStandardPeriod;
        }
        return object_utils_1.default.getApplyPlanText(salesForceInfo.oldStandardProductPlanName, salesForceInfo.oldStandardPriceBook2Description);
    };
    return ContractCompleteMailTemplate;
}());
exports.ContractCompleteMailTemplate = ContractCompleteMailTemplate;



//////////////////
// WEBPACK FOOTER
// ./src/utils/mail/template/contract_finish.ts
// module id = AVfP
// module chunks = 1